import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IBoosterAdvancedSettingsState} from "../reducers/booster-advanced-settings.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getBoosterAdvancedSettingsState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.boosterAdvancedSettings);

export const getBoosterAdvancedSettings = (websiteId: number) => createSelector(getBoosterAdvancedSettingsState,
  (state: IBoosterAdvancedSettingsState) =>
    (state.entities[websiteId] && state.entities[websiteId].entities) ? state.entities[websiteId].entities : null
);

export const getBoosterAdvancedSettingsLoading = (websiteId: number) => createSelector(getBoosterAdvancedSettingsState,
  (state: IBoosterAdvancedSettingsState) =>
    state.entities[websiteId].loading
);

export const getBoosterAdvancedSettingsLoaded = (websiteId: number) => createSelector(getBoosterAdvancedSettingsState,
  (state: IBoosterAdvancedSettingsState) =>
    state.entities[websiteId] ? state.entities[websiteId].loaded : false
);
